"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIdentityRef = useIdentityRef;
const react_1 = require("react");
/**
 * Реф с актуальным переданным значением.
 * Нужен, когда в ref нужно обновлять значение при каждом рендере.
 * @param value Значение.
 * @return Реф.
 */
function useIdentityRef(value) {
    const ref = (0, react_1.useRef)(value);
    ref.current = value;
    return ref;
}
//# sourceMappingURL=index.js.map